"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _underscore = _interopRequireDefault(require("underscore"));

var _DraggableRow = _interopRequireDefault(require("./DraggableRow"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DroppableWrapper = (
/*#__PURE__*/
0, _styledBase.default)('div', {
  target: "ebmtl4h0",
  label: "DroppableWrapper"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var Container = function Container(_ref) {
  var children = _ref.children,
      hideDeleteIcon = _ref.hideDeleteIcon,
      canBeEmpty = _ref.canBeEmpty,
      onDragEnd = _ref.onDragEnd,
      onDelete = _ref.onDelete;

  var _useState = (0, _react.useState)(_underscore.default.uniqueId('droppable-')),
      _useState2 = _slicedToArray(_useState, 1),
      droppableId = _useState2[0];

  return _react.default.createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, _react.default.createElement(_reactBeautifulDnd.Droppable, {
    droppableId: droppableId
  }, function (provided) {
    return _react.default.createElement(DroppableWrapper, _extends({
      ref: provided.innerRef
    }, provided.droppableProps), children.map(function (child, index) {
      return _react.default.createElement(_DraggableRow.default, {
        key: index.toString(),
        index: index,
        child: child,
        hideDeleteIcon: hideDeleteIcon,
        onDelete: onDelete,
        canBeEmpty: canBeEmpty
      });
    }), provided.placeholder);
  }));
};

Container.propTypes = {
  children: _propTypes.default.node.isRequired,
  hideDeleteIcon: _propTypes.default.bool,
  canBeEmpty: _propTypes.default.bool,
  onDragEnd: _propTypes.default.func.isRequired,
  onDelete: _propTypes.default.func
};
Container.defaultProps = {
  hideDeleteIcon: false,
  canBeEmpty: true,
  onDelete: function onDelete() {}
};
var _default = Container;
exports.default = _default;